// extracted by mini-css-extract-plugin
module.exports = {"afterpaymentcont":"PaymentAfter_afterpaymentcont__1hLU5","profilebutton":"PaymentAfter_profilebutton__PdsQJ"};